import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {
  AbstractControl,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {Dropdown} from "primeng/primeng";

@Component({
  selector: 'yes-no',
  templateUrl: './yes-no.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => YesNoComponent),
    multi: true
  },
  {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => YesNoComponent),
    multi: true,
  }]
})
export class YesNoComponent implements OnInit, OnChanges, Validator{

  public yesNo = [
    {value: null, label: "-"},
    {value: true, label: "Oui"},
    {value: false, label: "Non"}
  ];

  @Input()
  name: string;

  @Output()
  onChange:EventEmitter<any> = new EventEmitter();

  @ViewChild('ynDropdown') ynDropdown: Dropdown;

  _value: boolean;
  public touched:boolean;
  public control:AbstractControl;

  ngOnInit(): void {
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onModelChange(this._value);
  }

  onModelChange: (_: any) => void = (_: any) => {
  };
  onModelTouched: () => void = () => {
    this.touched = true;
  };


  registerOnValidatorChange(fn: () => void): void {
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
}

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
}

  writeValue(obj: any): void {
    this._value = obj;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.onModelChange(this._value);
  }

  setDisabledState(isDisabled: boolean): void {
    this.ynDropdown.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if(control && control.parent && this.touched){
      control.parent.markAsTouched();
      control.markAsTouched();
    }
    if(control){
      this.control = control;
    }
    if(control && control.enabled) {
      return control.errors;
    }
    return null;
  }

  get enabled(){
    return this.control && this.control.enabled;
  }

}

